import request from '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export const getReserVationTime = (params = {}) => {
    const new_params = { ...getParameter(), ...params }
    return request.get(getBaseUrl() + '/placereservation/bydate', { params: new_params })
}

export const checkreservationAvailability = (body = {}) => {
    return request.post(getBaseUrl() + '/placereservation/checkreservationavailability', body)
}

export const checkSpecialPrice = (params = {}) => {
    const new_params = { ...getParameter(), ...params }
    return request.get(getBaseUrl() + '/placereservation/checkspecialprice', { params: new_params })
}